<template>
  <div class="valore-index-page">
    <div class="top-section">
      <div class="top-box">
        <img v-if="antiShowTag == 1" class="success2-logo" src="/static/images/valore/warn2.png" />
        <img v-if="antiShowTag == 2" class="success2-logo" src="/static/images/valore/red-warn.png" />
        <img v-if="antiShowTag == 3" class="success2-logo" src="/static/images/valore/success2.png" />
        <div v-if="antiShowTag == 1" class="auth-text">您所查询的数码错误</div>
        <div v-if="antiShowTag == 2" class="auth-text">您所查询的数码不存在</div>
        <div v-if="antiShowTag == 3" class="auth-text">VALORE正品认证</div>
      </div>
    </div>

    <div class="middle-section">
      <div v-if="antiShowTag == 1" class="no-product-wrapper">
        <img class="success-logo" src="/static/images/valore/barcode-warn.png" />
        <div class="info-container">
          <div class="no-match-text">未能匹配到产品信息</div>
          <div class="product-code">产品数码：{{ antiCode }}</div>
        </div>
        <div class="contact-container">
          <img class="wecom-img" src="/static/images/valore/wecom.png" />
          <div class="contact-text">-联系官方客服咨询-</div>
        </div>
      </div>

      <div v-if="antiShowTag == 2" class="anti-error-wrapper">
        <img class="success-logo" src="/static/images/valore/red-barcode-warn.png" />
        <div class="info-container">
          <div class="no-match-text">谨防假冒，请核对后重新查询</div>
          <div class="product-code">产品数码：{{ antiCode }}</div>
        </div>
        <div class="contact-container-buttons">
          <div class="btn-black" @click="reScan">重新查询</div>
          <div class="btn-gray" @click="handleRuleClick">积分规则说明</div>
        </div>
      </div>

      <div v-if="antiShowTag == 3" class="normal-query-wrapper">
        <div class="product-image-box">
          <img class="product-image" :src="productImage" />
        </div>
        <div class="normal-info-container">
          <div class="product-name-text">{{ productName }}</div>
          <div class="product-model-text">产品型号：{{ productNo }}</div>
        </div>
        <div class="normal-buttons-container">
          <div class="btn-black" @click="handleJoin">领取积分</div>
          <div class="btn-gray" @click="handleRuleClick">积分规则说明</div>
        </div>
      </div>
    </div>

    <div class="bottom-section">
      <div class="bottom-text">最终解释权归 VALORE AOE 所有</div>
    </div>
  </div>
</template>

<style scoped>
.valore-index-page {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}

.top-section {
  width: 100vw;
  height: 12vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.middle-section {
  width: 100vw;
  height: 78vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bottom-section {
  width: 100vw;
  height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.success-logo {
  width: 42vw;
  margin-left: 10vw;
  height: auto;
  margin-top: 8vh;
}

.top-box {
  width: 85vw;
  height: 6vh;
  background-color: rgb(235, 235, 235);
  border-radius: 8px;
  border: 1px solid rgb(200, 200, 200);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.success2-logo {
  width: 5.5vw;
  height: auto;
  margin-right: 2vw;
}

.bottom-text {
  width: 100vw;
  text-align: center;
  font-weight: 300;
  color: rgb(204, 204, 204);
  font-size: 3.6vw;
  margin-top: auto;
  margin-bottom: 3vh;
}

.no-product-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.anti-error-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.normal-query-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.product-image-box {
  width: 85vw;
  height: 50vh;
  border-radius: 15px;
  border: 1px solid rgb(235, 235, 235);
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image {
  width: auto;
  height: 75%;
}

.info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 8vh;
}

.normal-info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3vh;
}

.product-name-text {
  color: rgb(0, 0, 0);
  font-size: 4.2vw;
}

.product-model-text {
  color: rgb(132, 132, 132);
  font-size: 3.8vw;
  margin-top: 0.5vh;
  letter-spacing: 1.8px;
  font-weight: 300;
}

.no-match-text {
  color: rgb(0, 0, 0);
  font-size: 4.2vw;
}

.product-code {
  color: rgb(132, 132, 132);
  font-size: 3.8vw;
  margin-top: 0.5vh;
  letter-spacing: 1.8px;
  font-weight: 300;
}

.contact-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 8vh;
}

.contact-container-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90vw;
  margin-top: 8vh;
}

.normal-buttons-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90vw;
  margin-top: 3vh;
}

.btn-black {
  width: 90vw;
  height: 6vh;
  background-color: rgb(26, 26, 26);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.3vw;
  margin-bottom: 1.5vh;
}

.btn-gray {
  width: 90vw;
  height: 6vh;
  background-color: rgb(235, 235, 235);
  color: black;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.3vw;
}

.wecom-img {
  width: 35vw;
  height: auto;
}

.contact-text {
  color: rgb(132, 132, 132);
  margin-top: 0.5vh;
  font-size: 3.5vw;
  letter-spacing: 1px;
}

.auth-text {
  color: rgb(17, 17, 17);
  font-size: 4vw;
}
</style>

<script>
import { getAntiResult, getInfoByCode, getJSSDK, getWechatAuth } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'ValoreIndex',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138845780488' : '138614328487',
      appId: process.env.ENV_NUM === '1' ? 'wxd47d6bc665581d41' : 'wx885161c495be58a3',
      antiCode: '',
      deptId: '',
      productName: '',
      productNo: '',
      productImage: '',
      antiShowTag: 0,
    }
  },
  methods: {
    async queryAntiResult(code) {
      const res = await getAntiResult(code)
      return res && res.data ? res.data : {}
    },
    async queryProductInfo() {
      const productRes = await getInfoByCode(this.$route.query.c)
      return productRes && productRes.data && productRes.data.data ? productRes.data.data : {}
    },
    async handleJoin() {
      const redirectUrl = window.location.origin + '/valore/activity';
      const params = new URLSearchParams();
      params.append('eno', this.eno);
      params.append('c', this.antiCode);
      params.append('deptId', this.deptId);

      const fullRedirectUrl = redirectUrl + '?' + params.toString();

      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err => {
        alert("获取微信授权失败" + err);
      });
    },
    handleRuleClick() {
      this.$router.push({
        path: '/valore/rule',
      })
    },
    reScan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
          }
          this.antiCode = scanQRCode.substring(0, 16)
          this.initQuery(scanQRCode)
        }
      });
    },
    async initQuery(code) {
      try {
        const data = await this.queryAntiResult(code)
        if (data.code === '300101' || data.code === '300102') {
          if (data.data) {
            this.deptId = data.data.deptId
            this.antiCode = data.data.code
          }
          const productInfo = await this.queryProductInfo()
          this.productName = productInfo && productInfo.productName ? productInfo.productName : ''
          this.productNo = productInfo && productInfo.productNo ? productInfo.productNo : ''
          this.productImage = productInfo && productInfo.productImage ? productInfo.productImage : ''
          if (!this.productNo) {
            this.antiShowTag = 1
          } else {
            this.antiShowTag = 3
          }
        } else if (data.code === '500') {
          this.antiCode = code.length > 16 ? code.substring(0, 16) : code
          this.antiShowTag = 2
        } else if (data.code === '300106') {
          this.antiCode = code.length > 16 ? code.substring(0, 16) : code
          this.antiShowTag = 2
        }
      } catch (err) {
        this.productNo = ''
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  async mounted() {
    var params = this.$route.query
    //this.code = params.c
    await this.initQuery(params.c)
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Valore/Index.vue